// export const baseUrl="http://65.2.68.111:7000/api";
// export const baseUrl="http://10.161.115.196:3000/api/";
export const baseUrl="https://app.summairsportsclub.org/api";
